module.exports = __webpack_public_path__ + "static/og-afe9068659cd3d41ad2053bcf11153bf.png";